module.exports = __webpack_public_path__ + "img/dark_tip_ico.a2dbf0a2.png";